import { ArrowRight, CheckCircle2, DownloadCloud, KeyRound, UserRoundPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'

const steps = [
  {
    number: '01',
    icon: UserRoundPlus,
    title: 'Add your account',
    body: 'Enter your email address. NewEmail checks common providers and published mail settings, then fills in the IMAP and SMTP details for you.',
  },
  {
    number: '02',
    icon: DownloadCloud,
    title: 'Let your inbox sync',
    body: 'Recent folders and messages are cached locally. Once the first sync finishes, moving around your inbox stays quick and familiar.',
  },
  {
    number: '03',
    icon: KeyRound,
    title: 'Read, write, and get on with it',
    body: 'Reply, forward, search, switch accounts, and keep your mail organized. Credentials are kept separately in your system Keychain.',
  },
]

export function GetStarted() {
  return (
    <section id="get-started" className="py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
        <div className="lg:sticky lg:top-24">
          <span className="font-mono text-sm font-semibold text-primary">// getting started</span>
          <h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl">
            From download to inbox in minutes.
          </h2>
          <p className="mt-4 max-w-md text-pretty leading-relaxed text-muted-foreground">
            NewEmail uses standard mail protocols, so you keep your existing address and provider.
            There is no migration and no new inbox to manage.
          </p>
          <div className="mt-6 space-y-2 text-sm text-muted-foreground">
            {['Your address stays yours', 'No mail forwarded through us', 'Remove an account at any time'].map(
              (item) => (
                <p key={item} className="flex items-center gap-2">
                  <CheckCircle2 className="h-4 w-4 text-primary" />
                  {item}
                </p>
              ),
            )}
          </div>
          <Button
            className="mt-7"
            nativeButton={false}
            render={<a href="/docs" />}
          >
            Read the setup guide
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>

        <div className="relative">
          <div className="absolute bottom-8 left-[27px] top-8 w-px bg-border sm:left-[31px]" />
          <div className="space-y-4">
            {steps.map(({ number, icon: Icon, title, body }) => (
              <article
                key={number}
                className="relative flex gap-5 rounded-2xl border border-border bg-card p-6 shadow-[0_12px_35px_-30px_rgba(71,33,20,0.55)] sm:gap-6 sm:p-7"
              >
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/20">
                  <Icon className="h-6 w-6" />
                </span>
                <div>
                  <span className="font-mono text-[11px] font-bold text-primary">{number}</span>
                  <h3 className="mt-1 text-lg font-bold tracking-tight">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{body}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
